import { Tooltip } from 'antd';
import { ShieldAlert } from 'lucide-react';
import { Aks2talOnly } from 'components/AdminOnly';

export default function InternalSchemaFieldIndicator({
  isDefaultField,
  isCustomField,
}: {
  isDefaultField: boolean;
  isCustomField: boolean;
}) {
  return (
    <Aks2talOnly>
      {isDefaultField && !isCustomField ? (
        <Tooltip title="Standard skema felt">
          <ShieldAlert className="text-amber-500" style={{ width: 18, height: 18 }} />
        </Tooltip>
      ) : null}
    </Aks2talOnly>
  );
}
